import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';

type Props = {
  addJoinKeyHref: string;
};

/**
 * {@link EmptyJoinKeys} is an empty state for the join keys page, giving the user a CTA to add one.
 */
export function EmptyJoinKeys({ addJoinKeyHref }: Props) {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3">You don’t have any join keys set up</h2>
        <p className="p-lt mb-24">
          A join key is a reusable enrollment code. Use it like a normal enrollment code to enroll any number of
          machines. Each will join as a new host with the join key’s network, role and tags. Join keys are a good fit
          for CI workflows, autoscaling rollouts, and MDM rollouts.
        </p>
        <LinkButton to={addJoinKeyHref}>Create join key</LinkButton>
      </div>
    </CenteredLayout>
  );
}
